import useTheme from '@mui/material/styles/useTheme';
import { alpha } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import NodeForm from '../form/NodeForm';
import { CreateWorkflowNode, WorkflowNode, WorkflowNodeType } from 'api/model';
import { ReactFlowInstance } from 'reactflow';

class NodeFormEvent extends Event {
  constructor(data: NodeFormEventData) {
    super('open-node-form');
    this.data = data;
  }
  data: NodeFormEventData;
}

type NodeFormEventData = {
  nodeType: WorkflowNodeType;
  flowInstance: ReactFlowInstance<WorkflowNode>;
  onSubmit: (formData: CreateWorkflowNode) => void;
  nodeId?: string;
  initialValues: CreateWorkflowNode | WorkflowNode;
};

const OverCanvasNodeFormView = () => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [nodeFormEvent, setNodeFormEvent] = useState<NodeFormEventData>();

  useEffect(() => {
    const handleCustomEvent = (event: Event) => {
      setNodeFormEvent((event as NodeFormEvent).data);
      setIsOpen(true);
    };
    document.addEventListener('open-node-form', handleCustomEvent);

    return () => {
      document.removeEventListener('open-node-form', handleCustomEvent);
    };
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleSubmit = useCallback(
    (formData: CreateWorkflowNode) => {
      nodeFormEvent?.onSubmit(formData);
      handleClose();
    },
    [nodeFormEvent, handleClose],
  );

  if (!isOpen || !nodeFormEvent) {
    return;
  }

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        background: alpha(theme.palette.background.default, 0.85),
        top: '0px',
        bottom: '0px',
        overflow: 'auto',
        zIndex: 20,
      }}
    >
      <div className="flex-grow flex justify-center p-8 md:p-12">
        <Box
          className="rounded-2xl w-full max-w-5xl p-6 overflow-hidden"
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            boxShadow: '0 24px 60px rgba(0, 0, 0, 0.5)',
          }}
        >
          <NodeForm
            nodeType={nodeFormEvent.nodeType}
            nodeId={nodeFormEvent.nodeId ?? ''}
            onCancel={handleClose}
            onSubmit={handleSubmit}
            initialValues={nodeFormEvent.initialValues}
            flowInstance={nodeFormEvent.flowInstance}
          />
        </Box>
      </div>
    </div>
  );
};

export { OverCanvasNodeFormView, NodeFormEvent };
